<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="80">
				<Select v-model="formValidate.status" style="width:200px">
					<Option :value="0" key="0">下线</Option>
					<Option :value="1" key="1">上线</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="兼职猫ID" :label-width="80">
				<Input v-model="formValidate.partTimeId" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="公司名称" :label-width="80">
				<Input v-model="formValidate.company" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="创建日期" prop="dateRange">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-start" placeholder="请选择" clearable />
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				apps: [],
				events: [],
				appId: '',
				advertType: 'table',
				formValidate: {
					status:1,
					company:'',
					partTimeId:'',
					dateRange: [],
				},
				dateRangeOptions: {
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			//获取全部app
			api.statistics
				.getAppPage({
					page: 1,
					limit: 100
				})
				.then(res => {
					this.apps = res.data.records
					if (this.apps.length > 0) {
						this.appId = this.apps[0].appKey
					}
				})
		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {}
				//this.formSubmit()
			},
			getFormData() {
				let beginTime = this.formValidate.dateRange[0] || null
				let endTime = this.formValidate.dateRange[1] || null
				const formData = {
					beginTime: beginTime ? this.util.formatDateTime(beginTime) : null,
					endTime: endTime ? this.util.dateFormat(endTime, 'yyyy-MM-dd') + ' 23:59:59' : null,
					status:this.formValidate.status,
					partTimeId:this.formValidate.partTimeId,
					company:this.formValidate.company,
				}
				return formData
			},

		}
	}
</script>